import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"

import "./Show.vue?vue&type=style&index=0&id=7bb15939&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb15939"]])

export default __exports__